import {useContext, useEffect} from 'react';
import {
  Box,
  alpha,
  Stack,
  IconButton,
  Tooltip,
  styled
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';

import HeaderUserbox from './Userbox';
import {ThemeToggle} from "../../../theme/ThemeToggle";
import UserContext from "../../../hooks/UserContext";
import {useTranslation} from 'react-i18next';
import AISearchButton from "../../../components/AISearchButton/AISearchButton";
import AIAssistantDrawer from "../../../components/AIAssistant/AIAssistantDrawer";
import { useAIAssistant } from "../../../hooks/AIAssistantContext";

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 1)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const { t } = useTranslation();
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { user } = useContext(UserContext);
  const { drawerOpen, openDrawer, closeDrawer, populateForm, getCurrentRecipe } = useAIAssistant();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (drawerOpen) {
          closeDrawer();
        } else {
          openDrawer();
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [drawerOpen, openDrawer, closeDrawer]);

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      displayPrint="none"
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
      >
      </Stack>
      <Box display="flex" alignItems="center">
        {user && <HeaderUserbox />}
        <ThemeToggle />
        <AISearchButton onClick={openDrawer} />
        <Box
          component="span"
          sx={{
            ml: 2,
            display: { lg: 'none', xs: 'inline-block' }
          }}
        >
          <Tooltip arrow title={t('common.toggleMenu')}>
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? (
                <MenuTwoToneIcon fontSize="small" />
              ) : (
                <CloseTwoToneIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <AIAssistantDrawer
        open={drawerOpen}
        onClose={closeDrawer}
        onPopulateRecipeForm={populateForm}
        getCurrentRecipe={getCurrentRecipe}
      />
    </HeaderWrapper>
  );
}

export default Header;
